









































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TitleOnboarding from '@/components/molecules/TitleOnboarding/TitleOnboarding.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import Radio from '@/components/molecules/Radio/Radio.vue';
import SingUpService from '@/api/SingupService';
import RegistrationService from '@/api/RegistrationService';
import eventBus from '@/utils/eventBus';

import { pluralize } from '@/utils';
import { updateRegistration } from '@/utils/updateRegistration';

@Component({
  components: {
    Typography,
    FilledButton,
    TextField,
    Radio,
    TitleOnboarding
  }
})
export default class RefundPolicy extends Vue {
  @Prop({ default: false }) readonly page?: boolean;
  optionSelected: string = '';
  inputValue: string = '';
  refundDays: number | null = null;
  loading: boolean = false;
  service = new SingUpService();
  registrationService = new RegistrationService();

  pluralize = pluralize;

  @Watch('optionSelected')
  onOption(newOption: string) {
    if (!isNaN(newOption as any)) {
      this.refundDays = Number(newOption);
    } else if (newOption === 'other') {
      this.refundDays = this.inputValue ? Number(this.inputValue) : null;
      setTimeout(() => {
        const otherInputRef = this.$refs.otherInput as any;
        otherInputRef.$refs.input.focus();
      });
    }
  }

  @Watch('inputValue')
  onOtherInput(newInputValue: string) {
    if (newInputValue === '') {
      this.refundDays = null;
    } else if (!isNaN(newInputValue as any)) {
      this.refundDays = Number(newInputValue);
    }
  }

  get refundDaysFormated() {
    const { refundDays } = this;

    if (refundDays === 0) {
      return 'immediately';
    }

    return `${
      refundDays === null || isNaN(refundDays) ? '-' : refundDays
    } ${pluralize(refundDays as number, 'day')}`;
  }

  get isValid() {
    return this.refundDays !== null && !isNaN(this.refundDays);
  }

  async submit() {
    const data = {
      refundsLimitDays: this.refundDays as number
    };

    this.loading = true;

    const res = await this.service.setRefundsDays(data);

    this.loading = false;
    if (res && res.status === 200) {
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        refundsLimitDays: res.data.refundsLimitDays
      });
      updateRegistration('return-policy');
      this.$emit('save', res.data);
      return;
    }
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  onBusinessInfo(businessInfo: any) {
    if (businessInfo && typeof businessInfo.refundsLimitDays === 'number') {
      const { refundsLimitDays } = businessInfo;
      if ([0, 14, 30, 60].includes(refundsLimitDays)) {
        this.optionSelected = `${refundsLimitDays}`;
      } else {
        this.optionSelected = 'other';
      }
      this.inputValue = `${refundsLimitDays}`;
    }
  }

  mounted() {
    this.onBusinessInfo(this.businessInfo);

    eventBus.$on('setBusinessInfo', this.onBusinessInfo);
  }
}
